<div class="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
  <div class="bg-white rounded-lg p-6 w-11/12 max-w-md">
    <h2 class="text-xl font-bold mb-2">{{ data.title }}</h2>

    <p class="mb-1 text-gray-800">{{ data.message }}</p>
    <p class="mb-3 text-gray-700 text-sm" *ngIf="!data.hideWarning">This could take upwards of 10 minutes.</p>
    <div class="relative">
      <div class="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
        <div class="bg-blue-600 h-full transition-all duration-500 ease-in-out" [style.width.%]="data.progress"></div>
      </div>
      <div class="absolute top-0 right-0 -mt-5 mr-2 text-sm text-gray-700">
        {{ progressFraction }}
      </div>

    </div>

    <div class="mt-2 text-md text-red-500 font-semibold" *ngIf="!data.hideWarning">Please do not close this page.</div>

    <!-- Cancel Button -->
    <div class="mt-4 flex justify-end" *ngIf="data.enableCancel">
      <button (click)="onCancel()"
        class="px-3 py-1.5 text-sm font-medium text-white bg-red-500 hover:bg-red-600 border border-transparent rounded-md shadow-sm inline-flex items-center gap-1.5 focus:outline-none transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
        {{ data.cancelText || 'Cancel' }}
      </button>
    </div>
  </div>
</div>